import { useEffect, useState } from "react";
import Tagify from "../../../components/tagify/Tagify";
import { API_ROUTES } from "../../../core/Constants";
import { TagifyDataItem } from "../../../models/TagifyOptions";
import DataItem from "../../../models/DataItem";
import { useHub } from "../../../core/Global";
import TextArea from "../../../components/form/TextArea";
import { useNavigate } from "react-router-dom";
import { DrawerForm } from "../../../components/drawers/DrawerForm";
import PhoneNumberSelect from "../../../components/form/PhoneNumberSelect";


interface IProps {

    onClose: () => void
    prefillPhone?: string
}
export default function NewChatModal(props: IProps) {

    const hub = useHub()
    const navigate = useNavigate()

    const [selectedContact, selectedContactSet] = useState<TagifyDataItem>();

    const [techs, techsSet] = useState<DataItem[]>([]);
    const [jobs, jobsSet] = useState<DataItem[]>([]);

    // PhoneNumberSelect posts no form control of its own, so the line is held here and merged
    // into the body on submit.
    const [fromLineId, fromLineIdSet] = useState<string>();

    useEffect(() => {
        hub.Get(API_ROUTES.Chat + "recipients/techs", res => techsSet(res.data))
    }, [])


    return (
        <DrawerForm id="modal-start-newchat"
            title="New Chat"
            buttonText="Start New Chat"
            onClose={props.onClose}
            onSubmit={(body, callback) => {


                hub.Post(API_ROUTES.ChatStart, { ...body, from: fromLineId }, res => {
                    if (res.success) {
                        navigate("/chat/" + res.data);
                    }
                    else if (res.field) {
                        window.formError(res.field, res.message ?? "", "modal-start-newchat");
                    }

                    callback!(res);
                })


            }}>

            <div>

                <PhoneNumberSelect id="drp-startchat-from" name="from" label="From" labelUp block autoSelectFirst markDefaultSender
                    value={fromLineId} onChange={fromLineIdSet} />

                <Tagify id="tagify-startchat-contact" key="tagify-startchat-contact"
                    name="to" label="To" labelUp block liveSearch freeTags
                    placeholder="Search phone number, technician, job, contact..."
                    defaultValue={props.prefillPhone}
                    apiUrl={API_ROUTES.TagifyChatContacts} />

                <TextArea name="message" label="Message" labelUp block placeholder="Write a message..." rows={6} />

            </div>
        </DrawerForm>
    )
}
